package com.bikompanion.ui.home

data class StationFocusTarget(
    val networkId: String,
    val stationId: String,
)
